import type { CookiesConsentParams } from '../types';

export class CookiesConsent {
	private static instance: CookiesConsent;

	init: (...args: unknown[]) => void;
	isGroupAllowed: (...args: unknown[]) => void;
	registerService: (...args: unknown[]) => void;
	unregisterService: (...args: unknown[]) => void;
	getCookiesGroupsState: () => Record<string, boolean>;
	getConsentedDate: () => string | null | undefined;

	constructor(params: CookiesConsentParams) {
		const notImplemented =
			(fnName: string) =>
			(...args: unknown[]) => {
				// eslint-disable-next-line no-console
				console.error(`CookiesConsent.${fnName}: Not implemented`, ...args);
			};

		this.init = params.init || notImplemented('init');
		this.isGroupAllowed = params.isGroupAllowed || notImplemented('isGroupAllowed');
		this.registerService = params.registerService || notImplemented('registerService');
		this.unregisterService = params.unregisterService || notImplemented('unregisterService');
		this.getCookiesGroupsState =
			params.getCookiesGroupsState || (notImplemented('getCookiesGroupsState') as () => Record<string, boolean>);
		this.getConsentedDate =
			params.getConsentedDate || (notImplemented('getConsentedDate') as () => string | null);
	}

	static build(params: CookiesConsentParams): CookiesConsent {
		if (!CookiesConsent.instance) {
			CookiesConsent.instance = new CookiesConsent(params);
		} else {
			// eslint-disable-next-line no-console
			console.error('CookiesConsent already built');
		}
		return CookiesConsent.instance;
	}

	static getInstance(): CookiesConsent {
		if (!CookiesConsent.instance) {
			// eslint-disable-next-line no-console
			console.error('CookiesConsent needs to be built');
			CookiesConsent.instance = new CookiesConsent({
				getCookiesGroupsState: () => ({}),
				getConsentedDate: () => null,
			});
		}
		return CookiesConsent.instance;
	}
}
